import * as angular from 'angular';
import {IController} from "angular";
import * as _ from "lodash";

export class AgentsValidationTableRow implements IController {
  agent: any;
  agentId: any;
  onToggle: any;
  onRemove: any;
  onEdit: Function;

  private readonly siteLabels: any;
  private errorFields: any;

  /* @ngInject */
  constructor() {

  }

  $onInit() {
    this.errorFields = [];
    this.errorFields = _.map(this.agent.mappingErrors, (error) => {
      return error.fieldName;
    });
  }

  $onChanges(changes) {
    if (changes.agentId && !changes.agentId.isFirstChange()) {
      this.$onInit();
    }
  };

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  getErrorDescriptions() {
    return _.map(this.agent.mappingErrors, 'description');
  }

  isMissing(type, name) {
    var stringName = 'agent.' + _.toLower(type) + '.' + name;
    var matchedError = _.find(this.errorFields, (e) => {
      return _.includes(e, stringName);
    });

    return !_.isUndefined(matchedError);
  }

}

angular
  .module('bringoz.admin.agents')
  .component('agentsValidationTableRow', {
    require: {
      agentsValidationTableCtrl: '^agentsValidationTable'
    },
    bindings: {
      agent: '<',
      agentId: '<',
      onToggle: '&',
      onRemove: '&',
      onEdit: '&'
    },
    template: require('./agents-validation-table-row.html').default,
    controller: AgentsValidationTableRow
  });
